<template>
  <div v-show="logueado" id="solicitardespacho" class="container br-2-blue">
    
    <div id="solicitar" class="separador contenido" v-if="solicitarDiv">
      <div class="panel panel-default">
        <h2 class="text-center">Facturación y Entrega de Paquetes</h2>
        <div class="table-responsive app-table">
          <table class="table table-striped b-t table-color">
            <thead class="app-bkg-color-f5">
              <tr style="font-size: 11px">
                <th>F. Recibido</th>
                <th>Tracking</th>
                <th>Estado</th>
                <th>Contenido</th>
                <th>Tienda</th>
                <th>HAWB</th>
                <th>Servicio</th>
                <th>Peso Lbs</th>
                <th>Orden Compra (P.O)</th>
                <th>Valor Servicios</th>
                <th>Valor Impuestos</th>
                <th>Valor Total</th>
              </tr>
            </thead>
              <tbody>
                <tr v-for="consolidada in consolidadas" v-bind:key="consolidada.id" style="font-size: 11px">
                  <td style="width: 5%;font-size: 11px" class="ng-binding">{{consolidada.fecha_recibido}}</td>
                  <td style="width: 13%;font-size: 11px;white-space: normal;word-break: break-all" class="ng-binding">{{consolidada.tracking}}</td>
                  <td style="width: 10%;font-size: 11px;white-space: normal;word-break: break-all" class="ng-binding">{{consolidada.estado}}</td>
                  <td style="width: 13%;font-size: 11px;white-space: normal;word-break: break-all" class="ng-binding">{{consolidada.contenido}}</td>
                  <td style="width: 10%;font-size: 11px;white-space: normal;word-break: break-all" class="ng-binding">{{consolidada.tienda}}</td>
                  <td style="width: 10%" class="ng-binding">{{consolidada.hawb}}</td>
                  <td style="width: 10%;font-size: 11px;white-space: normal;word-break: break-all" class="ng-binding">{{consolidada.servicio}}</td>
                  <td style="width: 5%" class="ng-binding">{{consolidada.peso}}</td>
                  <td style="width: 10%" class="ng-binding">{{consolidada.orden_de_compra}}</td>
                  <td>{{ consolidada.valor_servicios }}</td>
                  <td>{{ consolidada.valor_impuestos }} </td>
                  <td>{{ consolidada.valor_total }}</td>
                </tr>
                <tr>
                  <td colspan="8"></td>
                  <td class="font-weight-bold text-right">Totales:</td>
                  <td>{{total_servicios}}</td>
                  <td>{{total_impuestos}}</td>
                  <td>{{total_factura}}</td>
                </tr>
              </tbody>
          </table>
        </div>
        <form @submit.prevent="preliquidar">
            <div class="form-row">
              <div class="form-group col-md-6">
                <label>Destinatarios *</label>
                <select class="form-control" v-model="selectDestinatario" name="destinatario" v-validate="'required'" :class="{ 'is-invalid': submittedPreliquidar && errors.has('destinatario') }">
                  <option
                    v-for="destinatario in destinatarios"
                    :value="destinatario.id"
                    v-bind:key="destinatario.id"
                  >{{destinatario.nombre_completo}}</option>
                </select>
              </div>
              <div class="form-group col-md-6">
                <label>Medio de Pago:</label><br>
                <input type="text" value="Tarjeta credito" disabled class="form-control">
              </div>
            </div>
            <button class="btn btn-dark" v-on:click="cerrarSolicitud" title="Volver">Cancelar</button>
            <button class="btn btn-blue ml-2 btn-enviar">Facturar</button>
        </form>
      </div>
    </div>
    
    <b-modal size="sm" ok-variant="dark" v-model="showModalCargando" hide-footer hide-header no-close-on-backdrop no-close-on-esc centered>
      <Cargando/>
    </b-modal>

    <div id="listar" class="separador contenido" v-if="listar">
      <div class="panel panel-default">
        <h2 class="text-center">Facturación y Entrega de Paquetes</h2>
        <h4>Paquetes disponibles</h4>
        <div class="wrapper">
          <form class="form ng-pristine ng-valid" @submit.prevent="submit">
            <div class="row mb-3">
              <div class="col-md-4 col-sm-4 col-xs-4 col-lg-3">
                <a
                    class="btn btn-blue"
                    v-on:click="solicitar"
                    href="#"
                    v-if="consolidadas.length > 0"
                  ><b-icon icon="plus-circle-fill" aria-hidden="true"></b-icon> Solicitar</a>
              </div>
              <div class="form-row text-center justify-content-center col-md-4 col-sm-5 col-xs-6 col-lg-6">
                <label class="col-md-5 col-lg-2">Registros</label>
                <div>
                  <select
                    class="form-control"
                    name="registros"
                    v-validate="'required'"
                    :class="{ 'is-invalid': submitted && errors.has('registros') }"
                    v-model="registros"
                    @change="changePage()"
                  >
                    <option selected="selected" value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </div>
              </div>
            </div>  
            <div class="table-responsive app-table">
              <table class="table table-striped b-t table-color">
                <thead class="app-bkg-color-f5">
                  <tr style="font-size: 12px">
                    <th>Facturar</th>
                    <th>Fecha recibido</th>
                    <th>Tracking</th>
                    <th>Estado</th>
                    <th>HAWB</th>
                    <th>Contenido</th>
                    <th>Tienda</th>
                    <th>Servicio</th>
                    <th>Peso</th>
                    <th>Orden de Compra</th>
                    <th>Destinatario</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="consolidada in items"
                    v-bind:key="consolidada.id"
                    style="font-size: 12px;"
                  >
                    <td>
                      <b-form-checkbox v-model="consolidada.consolidar" @change="consolidar(consolidada)" name="check-button" switch></b-form-checkbox>
                    </td>
                    <td
                      style="width: 5%;font-size: 11px"
                      class="ng-binding"
                    >{{consolidada.fecha_recibido}}</td>
                    <td
                      style="width: 13%;font-size: 11px;white-space: normal;word-break: break-all"
                      class="ng-binding"
                    >{{consolidada.tracking}}</td>
                    <td
                      style="width: 10%;font-size: 11px;white-space: normal;word-break: break-all"
                      class="ng-binding"
                    >{{consolidada.estado}}</td>
                    <td
                      style="width: 12%;font-size: 11px;white-space: normal;word-break: break-all"
                      class="ng-binding"
                    >{{consolidada.hawb}}</td>
                    <td
                      style="width: 10%;font-size: 11px;white-space: normal;word-break: break-all"
                      class="ng-binding"
                    >{{consolidada.contenido}}</td>
                    <td style="width: 10%" class="ng-binding">{{consolidada.tienda}}</td>
                    <td
                      style="width: 10%;font-size: 11px;white-space: normal;word-break: break-all"
                      class="ng-binding"
                    >{{consolidada.servicio}}</td>
                    <td style="width: 5%" class="ng-binding">{{consolidada.peso}}</td>
                    <td style="width: 10%" class="ng-binding">{{consolidada.orden_de_compra}}</td>
                    <td style="width: 10%" class="ng-binding">{{consolidada.primer_nombre}} {{ consolidada.segundo_nombre}} {{consolidada.primer_apellido}} {{consolidada.segundo_apellido}}</td>
                  </tr>
                  <tr v-if="items.length == 0 && !cargandoDisponibles" class="text-center">
                    <td colspan="11">Sin registros</td>
                  </tr>
                </tbody>
              </table>
              <div v-show="cargandoDisponibles" class="text-center app-bkg-color-f5 app-no-data-table b-t" >
                <Cargando/>
              </div>
            </div>
            <div class="panel-footer">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRegistros"
                :per-page="registros"
                v-on:input="changePage"
                align="right"
              ></b-pagination>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div id="solicitudEnvio" class="separador contenido" v-if="solicitudEnvio">
      <div class="panel-body">
        <h3>SOLICITUD DE ENVIO: {{objetoPreliquidacion.id}}</h3>
        <h3 class="text-break">Observaciones: {{objetoPreliquidacion.observacion}}</h3>
        <button
          type="button"
          v-on:click="imprimirPDF(objetoPreliquidacion.id)"
          class="btn btn-blue"
          style="margin-bottom: 10px !important;float: right"
        >
          <b-icon icon="printer-fill" aria-hidden="true"></b-icon>Imprimir
        </button>
        <div class="table-responsive app-table">
          <table class="table table-striped b-t table-color">
            <thead class="app-bkg-color-f5" style>
              <tr>
                <th>Fecha recibido</th>
                <th>Tracking</th>
                <th>Estado</th>
                <th>Contenido</th>
                <th>Tienda</th>
                <th>Guía</th>
                <th>Servicio</th>
                <th>Peso lbs</th>
                <th>Orden de compra (P.O)</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              <tr
                v-for="paquete in objetoPreliquidacion.paquetes"
                v-bind:key="paquete.id"
                class="ng-scope"
              >
                <td class="ng-binding">{{paquete.created_at}}</td>
                <td class="ng-binding">{{paquete.tracking_tienda_casillero}}</td>
                <td class="ng-binding">{{paquete.estado}}</td>
                <td class="ng-binding">{{paquete.contenido}}</td>
                <td class="ng-binding">{{paquete.envio_casillero ? paquete.envio_casillero.tienda.razon_social : ''}}</td>
                <td class="ng-binding">{{paquete.hawb}}</td>
                <td class="ng-binding">{{paquete.envio_casillero ? paquete.envio_casillero.servicio.descripcion : ''}}</td>
                <td class="ng-binding">{{paquete.peso}}</td>
                <td class="ng-binding">{{paquete.orden_de_compra}}</td>
                <td></td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>
                  <div align="right">
                    <strong>TOTAL LBS</strong>
                  </div>
                </td>
                <td class="ng-binding">{{objetoPreliquidacion.total_lbs}}</td>
                <td>&nbsp;</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>
                  <div align="right">
                    <strong>TRANSPORTE</strong>
                  </div>
                </td>
                <td class="ng-binding">$ {{objetoPreliquidacion.valor}}</td>
                <td>USD</td>
              </tr>
              <tr>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>
                  <div align="right">
                    <strong>TRM</strong>
                  </div>
                </td>
                <td class="ng-binding">$ {{objetoPreliquidacion.trm_valor}}</td>
                <td>COP</td>
              </tr>
              <tr>
                <td colspan="7">
                  <div align="right">
                    <h6
                      style="color: red"
                    >Por favor no cancele este monto hasta que hayamos validado que la liquidación haya sido correcta, una vez verificado recibirás la factura en tu correo con el valor real y final.</h6>
                  </div>
                </td>
                <td>
                  <div align="right">
                    <strong>VALOR ESTIMADO</strong>
                  </div>
                </td>
                <td class="ng-binding">$ {{ objetoPreliquidacion.valor_moneda_cliente }}</td>
                <td>COP</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row">
          <div class="col-md-6">
            <br />
            <div class="form-inline" style="margin-bottom: 2rem;">
              <label for="soporte_pago" class>Adjuntar Comprobante de Pago</label>
  
              <b-form-file
                v-model="soportePago"
                :state="Boolean(soportePago)"
                placeholder="Escoja un archivo"
                drop-placeholder="Arrastre el archivo aquí.."
                browse-text="Buscar"
                required
              ></b-form-file>
              <div class="mt-3">Selected file: {{ soportePago ? soportePago.name : '' }}</div>
            </div>
          </div>
        </div>

        <button class="btn btn-dark" v-on:click="cerrarSolicitud" title="Volver">Cerrar</button>
        <a
          href="#"
          class="btn btn-dark btn-blue ml-2 btn-enviar"
          v-on:click="enviarSoporte(objetoPreliquidacion.id)"
          title="Enviar Soporte de Pago"
        ><b-icon icon="send-fill" aria-hidden="true"></b-icon> Enviar Soporte de Pago</a>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/plugins/api_conect";
import Cargando from '../layouts/Cargando.vue';
export default {
  computed: {
    logueado() {
      return this.$store.getters.loggedIn;
    }
  },
  components: {
    Cargando
  },
  methods: {
    imprimirPDF(id) {
      this.print = true;
      this.descargarPDF(id);
    },
    descargarPDF(id) {
      api().get(`/api/casillero/despachos/preliquidaciones/impresion-pdf/${id}`, {
              responseType: 'arraybuffer',
              headers: {
                'Accept': 'application/pdf',
                Authorization: localStorage.getItem('token_type') + " " + localStorage.getItem('access_token')
              }
          })
          .then(response => {
            const blob = new Blob([response.data], {
              type: 'application/pdf',
            });
            var url = window.URL.createObjectURL(blob);
            var a = document.createElement("a");
            if (this.print == true) {
              var w = window.open(url);
              w.print();
            } else if (this.print == false) {
              a.href = url;
              a.download = "solicitudEnvio" + id;
              document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
              a.click();
            }
            a.remove();
            this.print = false;
          })
          .catch(async (error) => {
            console.error(error);
            if (error.response && error.response.status === 401) {
              await this.$auth.refreshToken();
              this.descargarPDF(id);
            } else {
              this.$swal("error", 'Error', "error");
            }
          });
    },
    cleanSolicitar() {
      this.selectDestinatario = "";
    },
    enviarSoporte(id) {
      this.showModalCargando = true;
      var form_data = new FormData();
      form_data.append("soportePago", this.soportePago);

      api().post(`/api/casillero/subirsoportedepago/${id}`, form_data, {
            headers: {
              Accept: "application/json",
              'content-type': 'multipart/form-data',
              Authorization: localStorage.getItem('token_type') + " " + localStorage.getItem('access_token')
            },
          })
          .then(response => {
            const { data } = response;
            this.responseMessage = data["msg"];
            if (!data["error"]) {
              if (data["errores"]) {
                  for (let error in data["errores"]) {
                      if (
                          data["errores"][error] == "The soporte pago failed to upload."
                      ) {
                          this.responseMessage =
                              "El tamaño del archivo no puede ser mayor a 1 Mb.";
                      } else {
                          this.responseMessage += ". ";
                          this.responseMessage += data["errores"][error];
                      }
                  }
              }
              this.showModalCargando = false;
              this.$swal('Proceso completado', data["msg"], 'success');
            }
          }).catch(async (error) => {
            this.showModalCargando = false;
            if (error.response && error.response.status === 401) {
              await this.$auth.refreshToken();
              this.enviarSoporte(id);
            }else{
              this.$swal('Error','Ocurrio un error','error');
            }
          });
    },
    cerrarSolicitud() {
      this.consolidadas = [];
      this.getDatos();
      this.changePage();
      this.solicitudEnvio = false;
      this.solicitarDiv = false;
      this.listar = true;
    },
    getDatos() {
      api().get(`/api/casillero/despachos/preliquidaciones/infoform`, {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: localStorage.getItem('token_type') + " " + localStorage.getItem('access_token')
            }
          }).then(response => {
            const { data } = response;
            this.mediosDePago = data["datos"]["mediosDePago"];
            this.formasDePago = data["datos"]["formasDePago"];
            this.destinatarios = data["datos"]["destinatarios"];
            this.selectDestinatario = data["datos"]["destinatarios"][0].id;
            this.observaciones = "";
            this.total_factura = 0;
            this.total_impuestos = 0;
            this.total_servicios = 0;
            //eliminar forma de pago COD
            this.formasDePago.forEach(formaPago => {
              if (formaPago.descripcion == "CONTRA ENTREGA (COD)") {
                let index = this.formasDePago.indexOf(formaPago)
                this.formasDePago.splice(index, 1)
              }
            });
          }, err => {
            const { data } = err
            this.$swal('¡ERROR!', `Ha ocurrido un problema al obtener la informacion general\n${data.msg}`, 'error')
          })
          .catch(() => this.$swal('¡ERROR!','Ha ocurrido un error al obtener la informacion general', 'error'));
    },
    preliquidar: function() {
      this.submittedPreliquidar = true;
      this.responseMessage = "Espere un momento, cargando";

      this.$validator.validate().then(valid => {
        if (valid) {
          const datos = {
            cliente_id: localStorage.cliente_id,
            user_id: localStorage.user_id,
            paquetes: JSON.stringify(this.consolidadas),
            pago_id: 6,
            forma_de_pago_id: 1,
            destinatario_id: this.selectDestinatario,
            observacion: this.observaciones
          };

          api().post(`/api/casillero/despachos/preliquidaciones`, datos, {
                  headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                      Authorization: localStorage.getItem('token_type') + " " + localStorage.getItem('access_token')
                  },
              })
              .then(response => {
                const { data } = response;
                this.responseMessage = data["msg"];
                if (!data["error"]) {
                  if (!data["errores"]) {
                    if (data["msg"] == "Se preliquidaron los paquetes correctamente.") {
                      this.objetoPreliquidacion = data["datos"]["preliquidacion"];
                      this.solicitudEnvio = true;
                      this.solicitarDiv = false;
                      this.consolidadas = [];
                      this.cleanSolicitar();
                    }
                  }
                }
              }).catch(async (error) => {
                if (error.response && error.response.status === 401) {
                  await this.$auth.refreshToken();
                  this.preliquidar();
                }else{
                  let mensaje = error.response.data.msg ?? "Ocurrio un error"; 
                  this.$swal("error", mensaje, "error");
                }
              });
        }
      });
    },
    solicitar() {
      this.solicitarDiv = true;
      this.listar = false;
    },
    consolidar(object) {
      object.consolidar = !object.consolidar;
      let paquetes = [];

      if (object.consolidar && !this.consolidadas.find(element => element.id == object.id)) {
        this.consolidadas.push(object);
      } else if (!object.consoliddar) {
        this.consolidadas = this.consolidadas.filter(element => element.id != object.id);
      }

      for (var x = this.consolidadas.length - 1; x >= 0; x--) {
        paquetes.push(this.consolidadas[x].id);
      }

      const datos = {
        cliente_id: localStorage.cliente_id,
        user_id: localStorage.user_id,
        paquetes: JSON.stringify(paquetes)
      };

      if (object.consolidar) {
        api().post(`/api/casillero/despachos/preliquidaciones/solicitar`, datos, {
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: localStorage.getItem('token_type') + " " + localStorage.getItem('access_token')
              },
            }).then(response => {
              const { datos } = response.data;
              this.consolidadas = datos.paquetes;
              this.total_factura = datos.total_total;
              this.total_impuestos = datos.total_impuestos;
              this.total_servicios = datos.total_servicios;
            }).catch(async (error) => {
              if (error.response && error.response.status === 401) {
                await this.$auth.refreshToken();
                this.consolidar(object);
              }else{
                let mensaje = this.setErrors(error); 
                this.consolidadas = this.consolidadas.filter(element => element.id != object.id);
                object.consolidar = false;
                this.$swal("error", mensaje, "error");
              }
            });
      }
    },
    setErrors(error) {
      let mensaje = "";
      if (error.response.data["errores"]) {
        for (let err in error.response.data["errores"]) {
          mensaje += "<p>"+error.response.data["errores"][err]+"</p>";
        }
      }
      mensaje = mensaje == "" ? 'Ocurrio un error': mensaje;
      return mensaje
    },
    changePage() {
      this.items = [];
      this.cargandoDisponibles = true;
      let datos = { pageSize: this.registros, str_busqueda: '' };
      api().post(`/api/casillero/despachos/preliquidaciones/paqsdisponibles?page=${this.currentPage}`, datos, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: localStorage.getItem('token_type') + " " + localStorage.getItem('access_token')
                },
            })
            .then(response => {
              const { data } = response;
              this.responseMessage = data["msg"];
              if (!data["error"]) {
                this.cargandoDisponibles = false;
                if (!data["errores"]) {
                  this.items = data["datos"]["data"];
                  this.totalRegistros = data["datos"]["total"];
                } else {
                  for (let error in data["errores"]) {
                    this.responseMessage += ". ";
                    this.responseMessage += data["errores"][error];
                  }
                }
              }
            }, err => {
              const {data} = err
              this.$swal('¡ERROR!', `Ha ocurrido un problema al obtener la informacion de los paquetes\n${data.msg}`)
            }).catch( () => {
              this.$swal('¡ERROR!','Ha ocurrido un error al obtener la informacion de los paquetes', 'error')
            });
    },
    toogle() {
      this.crear = true;
    },
    closeCrear() {
      this.crear = false;
      this.clean();
      this.changePage();
    },
    submit: function() {}
  },
  data() {
    return {
      print: false,
      cargandoDisponibles: false,
      file: null,
      soportePago: [],
      objetoPreliquidacion: "",
      solicitudEnvio: false,
      preliquidaciones: "",
      totalPaginasPre: 0,
      observaciones: "",
      mediosDePago: "",
      formasDePago: [],
      destinatarios: "",
      selectDestinatario: "",
      listar: true,
      solicitarDiv: false,
      submitted: false,
      submittedPreliquidar: false,
      showModalCargando:false,
      responseMessage: "",
      registros: 10,
      actualPagina: 1,
      totalPaginas: 0,
      totalRegistros: 0,
      perPage: 3,
      currentPage: 1,
      items: [],
      fields: [
        "consolidar",
        "#",
        { key: "fecha_recibido", label: "Fecha recibido" },
        { key: "tracking", label: "Tracking" },
        { key: "estado", label: "Estado" },
        { key: "hawb", label: "HAWB" },
        { key: "contenido", label: "Contenido" },
        { key: "tienda", label: "Tienda" },
        { key: "servicio", label: "Servicio" },
        { key: "peso", label: "Peso" },
        { key: "orden_de_compra", label: "Orden de Compra" },
        { key: "destinatario", label: "Destinatario" }
      ],
      consolidadas: [],
      hawb: ""
    };
  },
  mounted: function() {
    this.$auth.refreshToken();
    this.changePage();
    this.getDatos();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  border-radius: 10px;
  margin-top: 25px;
  margin-bottom: 25px;
  padding: 15px;
}
.table-color {
  color: black !important;
  background: aliceblue !important;
}
input[type="number"]:focus{
  border: 2px solid var(--primary-color) !important;
  border-radius: 3px !important;
  outline: none !important;
}
.modal-dialog {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  min-height: calc(100% - 1rem) !important;
}
.modal-content {
  margin: 1.75rem auto !important;
  max-width: 500px !important;
}
@media screen and (max-width: 345px) {
  .btn-enviar{
    margin-top: 10px !important;
    margin-left: 0px !important;
  }
}
</style>